import React,{useRef,useState,useEffect} from 'react';
import { HomeChart } from '../../Components/Chart';
import {DataTable} from '../../Components'
import { FaRegUser,FaInfo  } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import { Controller, set, useForm } from "react-hook-form";

import {DateFormatJSON,ThaiMonth,DateThaiFormat, NumberFormat} from '../../Utils/Function';
import {} from '../../Utils/Status'
import { createRoot } from 'react-dom/client';
import ThaiDatePicker from '../../Components/ThaiDatePicker';
import moment from 'moment';
import Swal from 'sweetalert2';
import API from '../../API';

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';

import '../../Assets/CSS/TALFC.css';

const PageStoreSummary =()=> {
    const RedirectTo = useNavigate()
    const { register, getValues, setValue } = useForm();
    const [_Summary,setSummary] = useState(null);
    const [_StoreList,setStoreList] = useState([]);
    const [_StoreID,setStoreID] = useState(null);
    const [_StartDate, setStartDate] = useState(moment().add(-1,'month').toDate());
    const [_EndDate, setEndDate] = useState(new Date());

    const [_YearData,setYearData] = useState();
    const [_MonthData,setMonthData] = useState();
    const [_WeekData,setWeekData] = useState();
    const [_SearchData,setSearchData] = useState();

    ChartJS.register(
        CategoryScale,
        LinearScale,
        PointElement,
        LineElement,
        Title,
        Tooltip,
        Legend
    );
    useEffect(() => {
        //_Load();
        setStoreID(null);
        _LoadStore();

        const intervalId = setInterval(() => {
            //_Load(_Date);
        }, 600000);
        return () => {
            clearInterval(intervalId);
        };
    }, []);

    const _LoadStore = async()=>{
        API({method : "get",url:"/Staff/Store/List"}).then(res=>{
            if (!res.data.Status) {
                Swal.fire({
                    title: res.data.Message,
                    icon: 'error'
                });
                return;
            }
            setStoreList(res.data.Data);
        }).catch(res => {
            Swal.fire({
                title: res,
                icon: 'error'
            });
            return;
        });
    }
    const _Load = async() =>{
        if(_StoreID === null || _StoreID === '') return;
        Swal.showLoading();
        API({method : "get",url:"/Report/Store/"+_StoreID+"/Summary?Start="+DateFormatJSON(_StartDate,false)+"&End="+DateFormatJSON(_EndDate,false)}).then(res=>{
            Swal.close();
            if (!res.data.Status) {
                Swal.fire({
                    title: res.data.Message,
                    icon: 'error'
                });
                return;
            }
            setSummary(res.data.Data);

            let _YearLabels = [];
            let _YeaIncomeAmount = [];
            let _YeaShareAmount = [];
            let _YearTransaction = [];

            res.data.Data.Year.reverse().map((v,i)=>{
                const _Y = moment(v.AggregateDate).year();
                _YearLabels.push(_Y+543);
               _YeaIncomeAmount.push(v.IncomeAmount);
               _YeaShareAmount.push(v.ShareAmount);
               _YearTransaction.push(v.Transaction);
            });

            const _YearDataSet = {
                labels : _YearLabels,
                datasets:[
                    {
                    label: 'ยอดขาย',
                    data: _YeaIncomeAmount,
                    borderColor: 'rgb(255, 99, 132)',
                    backgroundColor: 'rgba(255, 99, 132, 0.5)',
                    },
                    {
                    label: 'ส่วนแบ่งรายได้',
                    data: _YeaShareAmount,
                    borderColor: 'rgb(167, 99, 255)',
                    backgroundColor: 'rgba(46, 25, 205, 0.5)',
                    }
                    ,
                    {
                    label: 'จำนวนรายการ',
                    data: _YearTransaction,
                    borderColor: 'rgb(44, 240, 112)',
                    backgroundColor: 'rgba(25, 143, 40, 0.5)',
                    }
                ]
            };
            setYearData(_YearDataSet);


            let _MonthLabels = [];
            let _MonthIncomeAmount = [];
            let _MonthShareAmount = [];
            let _MonthTransaction = [];

            res.data.Data.Month.reverse().map((v,i)=>{
                const _M = moment(v.AggregateDate).month();
                _MonthLabels.push(ThaiMonth(_M+1));
               _MonthIncomeAmount.push(v.IncomeAmount);
               _MonthShareAmount.push(v.ShareAmount);
               _MonthTransaction.push(v.Transaction);
            });

            const _MonthDataSet = {
                labels : _MonthLabels,
                datasets:[
                    {
                    label: 'ยอดขาย',
                    data: _MonthIncomeAmount,
                    borderColor: 'rgb(255, 99, 132)',
                    backgroundColor: 'rgba(255, 99, 132, 0.5)',
                    },
                    {
                    label: 'ส่วนแบ่งรายได้',
                    data: _MonthShareAmount,
                    borderColor: 'rgb(167, 99, 255)',
                    backgroundColor: 'rgba(46, 25, 205, 0.5)',
                    }
                    ,
                    {
                    label: 'จำนวนรายการ',
                    data: _MonthTransaction,
                    borderColor: 'rgb(44, 240, 112)',
                    backgroundColor: 'rgba(25, 143, 40, 0.5)',
                    }
                ]
            };
            setMonthData(_MonthDataSet);


            let _WeekLabels = [];
            let _WeekIncomeAmount = [];
            let _WeekShareAmount = [];
            let _WeekTransaction = [];

            res.data.Data.Week.reverse().map((v,i)=>{
                _WeekLabels.push(DateThaiFormat(v.AggregateDate,false));
               _WeekIncomeAmount.push(v.IncomeAmount);
               _WeekShareAmount.push(v.ShareAmount);
               _WeekTransaction.push(v.Transaction);
            });

            const _WeekDataSet = {
                labels : _WeekLabels,
                datasets:[
                    {
                    label: 'ยอดขาย',
                    data: _WeekIncomeAmount,
                    borderColor: 'rgb(255, 99, 132)',
                    backgroundColor: 'rgba(255, 99, 132, 0.5)',
                    },
                    {
                    label: 'ส่วนแบ่งรายได้',
                    data: _WeekShareAmount,
                    borderColor: 'rgb(167, 99, 255)',
                    backgroundColor: 'rgba(46, 25, 205, 0.5)',
                    }
                    ,
                    {
                    label: 'จำนวนรายการ',
                    data: _WeekTransaction,
                    borderColor: 'rgb(44, 240, 112)',
                    backgroundColor: 'rgba(25, 143, 40, 0.5)',
                    }
                ]
            };
            setWeekData(_WeekDataSet);

            let _Labels = [];
            let _IncomeAmount = [];
            let _ShareAmount = [];
            let _Transaction = [];

            res.data.Data.List.map((v,i)=>{
                _Labels.push(DateThaiFormat(v.AggregateDate,false));
               _IncomeAmount.push(v.IncomeAmount);
               _ShareAmount.push(v.ShareAmount);
               _Transaction.push(v.Transaction);
            });

            const _DataSet = {
                labels : _Labels,
                datasets:[
                    {
                    label: 'ยอดขาย',
                    data: _IncomeAmount,
                    borderColor: 'rgb(255, 99, 132)',
                    backgroundColor: 'rgba(255, 99, 132, 0.5)',
                    },
                    {
                    label: 'ส่วนแบ่งรายได้',
                    data: _ShareAmount,
                    borderColor: 'rgb(167, 99, 255)',
                    backgroundColor: 'rgba(46, 25, 205, 0.5)',
                    }
                    ,
                    {
                    label: 'จำนวนรายการ',
                    data: _Transaction,
                    borderColor: 'rgb(44, 240, 112)',
                    backgroundColor: 'rgba(25, 143, 40, 0.5)',
                    }
                ]
            };
            setSearchData(_DataSet);
        }).catch(res => {
            Swal.fire({
                title: res,
                icon: 'error'
            });
            return;
        });
    }

    const _OptionsYear = {
        responsive: true,
        plugins: {
            legend: {
            position: 'top',
            },
            title: {
            display: true,
            text: 'สถิติยอดขายรายปี',
            },
        },
    };

    const _OptionsMonth = {
        responsive: true,
        plugins: {
            legend: {
            position: 'top',
            },
            title: {
            display: true,
            text: 'สถิติยอดขายรายเดือน',
            },
        },
    };

    const _OptionsWeek = {
        responsive: true,
        plugins: {
            legend: {
            position: 'top',
            },
            title: {
            display: true,
            text: 'สถิติยอดขายรายสัปดาห์',
            },
        },
    };

    const _OptionsSearch = {
        responsive: true,
        plugins: {
            legend: {
            position: 'top',
            },
            title: {
            display: true,
            text: 'สถิติยอดขาย',
            },
        },
    };
    return (
        <>
        <React.Fragment>
            <div className='container-fluid'>
                <div className="row mt-2 mb-2 justify-content-end">
                    <div className='col-2 text-end'>
                        <ThaiDatePicker
                            className='form-control text-center'
                            selectsStart
                            selected={_StartDate}
                            onChange={(date) => { setStartDate(date); }}
                            startDate={_StartDate}
                            endDate={_EndDate}
                            placeholderText="วันที่ เริ่มต้น"
                        />
                    </div>
                    <div className='col-2 text-end'>
                        <ThaiDatePicker
                            className='form-control text-center'
                            selectsEnd
                            selected={_EndDate}
                            onChange={(date) => { setEndDate(date); }}
                            startDate={_StartDate}
                            endDate={_EndDate}
                            minDate={_StartDate}
                            placeholderText="วันที่ สิ้นสุด"
                        />
                    </div>
                    <div className='col-3'>
                        <select className='form-control' value={_StoreID} onChange={(e)=>{
                                setStoreID(e.target.value);
                             }}>
                            <option value={''}>เลือกร้านค้า</option>
                            {(_StoreList.map((v,i)=>(
                                <option key={i} value={v.StoreId}>{v.StoreCode} | {v.StoreName}</option>
                            )))}
                        </select>
                    </div>
                    <div className='col-1'>
                        <button className='btn btn-success btn-xs' onClick={()=>{
                            _Load();
                        }}>ค้นหา</button>
                    </div>
                </div>
                {(_Summary != null ?<>
                    <div className='row justify-content-center mt-4'>
                        <div className='col-10'>
                            <div className='card'>
                                <div className='card-header'>
                                    <h3>{_Summary.Store.StoreCode} | {_Summary.Store.StoreName}</h3>
                                </div>
                                <div classsName='card-body'>
                                    <div className='row'>
                                        <div className='col-4'>
                                            <div className='row'>
                                                <div className='col-12'>
                                                    {(_YearData != null ? <Line options={_OptionsYear} data={_YearData} /> : "")}
                                                </div>
                                            </div>
                                        </div>

                                        <div className='col-4'>
                                            <div className='row'>
                                                <div className='col-12'>
                                                    {(_MonthData != null ? <Line options={_OptionsMonth} data={_MonthData} /> : "")}
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-4'>
                                            <div className='row'>
                                                <div className='col-12'>
                                                    {(_MonthData != null ? <Line options={_OptionsWeek} data={_WeekData} /> : "")}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row justify-content-center mt-2 mb-2'>
                                        <div className='col-8'>
                                            {(_SearchData != null ? <Line options={_OptionsSearch} data={_SearchData} /> : "")}
                                        </div>
                                    </div>
                                    <div classsName='row justify-content-center mt-5'>
                                        <div className='col-12 table-responsive'>
                                            <table className='table'>
                                                <thead>
                                                    <tr>
                                                        <th className='text-center'>วันที่</th>
                                                        <th className='text-center'>จำนวนรายการขาย</th>
                                                        <th className='text-center'>ยอดขาย</th>
                                                        <th className='text-center'>ส่วนแบ่งรายได้</th>
                                                        <th className='text-center'>ยอดเงินสรุป</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {(_Summary.List.map((v,i)=>{
                                                        if(v.Transaction === 0 && v.TotalAmount === 0) return;
                                                        return (<tr key={i}>
                                                            <td className='text-center'>{DateThaiFormat(v.AggregateDate,false)}</td>
                                                            <td className='text-end'>{NumberFormat(v.Transaction)}</td>
                                                            <td className='text-end'>{NumberFormat(v.IncomeAmount)}</td>
                                                            <td className='text-end'>{NumberFormat(v.ShareAmount)}</td>
                                                            <td className='text-end'>{NumberFormat(v.TotalAmount)}</td>
                                                        </tr>)
                                                    }))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>:"")}
            </div>
        </React.Fragment>
        </>
    )
}

export default React.memo(PageStoreSummary)